{
  "info": "Informācija",
  "negative": "Kļūda",
  "notice": "Brīdinājums",
  "positive": "Izdevās"
}
